import type { ReactNode } from "react";
import { Icon } from "./Icon";

interface DrawerProps {
  title: string;
  open: boolean;
  onClose: () => void;
  children: ReactNode;
  width?: number;
  footer?: ReactNode;
}

// Right-side slide-in panel used for conversation transcripts and other
// read-mostly secondary detail views. Re-uses .modal-backdrop for the
// scrim so we don't have to ship new tokens.
export function Drawer({
  title,
  open,
  onClose,
  children,
  width = 520,
  footer,
}: DrawerProps): JSX.Element | null {
  if (!open) return null;
  return (
    <div className="modal-backdrop" onClick={onClose}>
      <aside
        className="drawer"
        role="dialog"
        aria-label={title}
        onClick={(e) => e.stopPropagation()}
        style={{
          position: "fixed",
          top: 0,
          right: 0,
          bottom: 0,
          width,
          maxWidth: "92vw",
          background: "var(--surface-1)",
          borderLeft: "1px solid var(--border-1)",
          display: "flex",
          flexDirection: "column",
          boxShadow: "var(--shadow-modal, 0 12px 30px rgba(0,0,0,.18))",
        }}
        data-testid={`drawer-${title.replace(/\s+/g, "-").toLowerCase()}`}
      >
        <header
          className="modal-head"
          style={{ borderBottom: "1px solid var(--border-1)" }}
        >
          <h3>{title}</h3>
          <button className="icon-btn" onClick={onClose} aria-label="Close">
            <Icon name="x" />
          </button>
        </header>
        <div
          className="modal-body"
          style={{ flex: 1, overflow: "auto" }}
        >
          {children}
        </div>
        {footer ? <div className="modal-foot">{footer}</div> : null}
      </aside>
    </div>
  );
}
